// import { useInfiniteQuery } from "@tanstack/react-query";
import { ReactComponent as AIEmoji16 } from "assets/svg/ai-emoji-16.svg";
import { ReactComponent as OutlineInfoCircle16 } from "assets/svg/outline-info-circle-16.svg";
import { ReactComponent as OutlineUsers16 } from "assets/svg/outline-users-16.svg";
import { useOrchidPro } from "components/Dashboard/DoctorDashboard/contexts/orchid-pro-context";
import PatientTypeTag from "components/Dashboard/DoctorDashboard/patient-charts/components/patient-type-tag/PatientTypeTag";
import SessionRepeatRuleEditor from "components/Dashboard/DoctorDashboard/views/one-one-sessions/components/session-repeat-rule-editor/SessionRepeatRuleEditor";
import { useCalendarTime } from "components/Dashboard/DoctorDashboard/views/one-one-sessions/contexts/CalendarTimeContext";
import { usePatientCreator } from "components/Dashboard/DoctorDashboard/views/one-one-sessions/contexts/patient-creator-context";
import getSessionEndTime from "components/Dashboard/DoctorDashboard/views/one-one-sessions/utils/getSessionEndTime";
import { AUDIO_SESSION_TYPES } from "components/ai-session-review/constants";
import ConfirmModal from "components/confirm-modal";
// import ConnectStripeBanner from "components/connect-stripe-banner/ConnectStripeBanner";
import CustomSelect from "components/custom-select/CustomSelect";
import RadioButton from "components/radio-button";
import RequiredAsterisk from "components/required-asterisk";
import ToggleSwitch from "components/toggle-switch";
import { useSessionTypes } from "contexts/SessionTypesContext";
import { useUser } from "contexts/UserContext";
import { useSubscription } from "contexts/subscription-context";
import useToggleModal from "hooks/useToggleModal";
import { isEqual } from "lodash";
import messages from "messages";
import moment, { MomentInput } from "moment-timezone";
// import { patientChartInfiniteQueryOptions } from "queries/patientChartQueryOptions";
import { useClientsContext } from "contexts/ClientsContext";
import { useCallback, useEffect, useMemo, useState } from "react";
import { Button, Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import switchSessionHeldPlace from "services/online-offline/switchSessionHeldPlace";
import postAppointmentSeries from "services/scheduler/postAppointmentSeries";
import postSessionTypes from "services/scheduler/postAppointmentTypes";
import queryZoomIntegrationStatus from "services/zoom/queryZoomIntegrationStatus";
import createZoomMeeting from "services/zoom/createZoomMeeting";
import {
  closeSidesheet,
  selectEditSeriesMode,
  selectNewSessionPlaceholder,
  setNewSessionPlaceholder,
  showSessionDetails,
} from "store/calendarSidebarSlice";
import { PRO_CALENDAR_ANALYTICS_PAGE_NAME, track } from "utils/amplitude";
import getClientDisplayName from "utils/getClientDisplayName";
import { getCoupleDisplayShortName } from "utils/getCoupleDisplayName";
import getSessionEndFromSessionLength from "utils/getSessionEndFromSessionLength";
import { disableStripeFeatures } from "utils/restrictAccess";
import searchClientsByName from "utils/searchClientsByName";
import { getAppointmentPatientName } from "../../../../../calendar-view/components/scrollable-calendar-view/components/appointment-timeslot/utils/getAppointmentPatientName";
import sessionSidesheetStyles from "../../../session-sidesheet/SessionSidesheet.module.scss";
import SidesheetWarning from "../../../sidesheet-warning/SidesheetWarning";
import addToCalendarStyles from "../../AddToCalendar.module.scss";
import { getAppointmentsByRepeatRule } from "../../utils/getAppointmentsByRepeatRule";
import isTimeValid from "../../utils/isTimeValid";
import styles from "./AddOrEditSession.module.scss";
import LocationSelector, {
  MeetingType,
} from "./components/location-selector/LocationSelector";
import MissingEmailModal from "./components/missing-email-modal/MissingEmailModal";
import SessionDateAndTime from "./components/session-time-and-date/SessionTimeAndDate";
import SessionTypeSelector from "./components/session-type-selector/SessionTypeSelector";
import useAppointmentsInSeries from "./useAppointmentsInSeries";
import { useQueryClient } from "@tanstack/react-query";
import updateZoomMeeting from "services/zoom/updateZoomMeeting";
import { extractZoomMeetingId } from "components/Dashboard/DoctorDashboard/views/one-one-sessions/components/layout/components/calendar-sidebar/components/session-sidesheet/session-details/delete-series-modal/DeleteSeriesModal";
import deleteZoomMeeting from "services/zoom/deleteZoomMeeting";
import modifyAppointmentSeries from "services/scheduler/modifyAppointmentSeries";
import rescheduleAppointment from "services/scheduler/rescheduleAppointment";
import { useTeamContext } from "contexts/group-practice-context/TeamContext";

interface AddOrEditSessionProps {
  initialIntervalStart: MomentInput;
  hasInitialTime: boolean;
  setIsDirty: React.Dispatch<React.SetStateAction<boolean>>;
  setShowNewSessionTypeWarningOnCancel: React.Dispatch<
    React.SetStateAction<boolean>
  >;
  isActive: boolean;
  currentSession?: AppointmentWithSeriesInfo & {
    invoice?: InvoiceData;
  };
}

const AMPLITUDE_COMPONENT_NAME = "add-new-session-modal";

const AddOrEditSession = ({
  initialIntervalStart,
  hasInitialTime,
  setIsDirty,
  setShowNewSessionTypeWarningOnCancel,
  isActive,
  currentSession,
}: AddOrEditSessionProps) => {
  const { user } = useUser();
  const [query, setQuery] = useState("");
  const [client, setClient] = useState<PatientChartResponseEntry>();

  const [zoomIntegrated, setZoomIntegrated] = useState(false);
  const [generateNoteOnlyWithSummary, setGenerateNoteOnlyWithSummary] =
    useState(false);

  useEffect(() => {
    queryZoomIntegrationStatus().then((res) => {
      setZoomIntegrated(res.is_connected);
    });
  }, []);

  const editSeriesMode = useSelector(selectEditSeriesMode);
  const newSessionPlaceholder = useSelector(selectNewSessionPlaceholder);

  // const patientChartQuery = useInfiniteQuery(
  //   patientChartInfiniteQueryOptions({
  //     clientStatus: ["patient", "waitlist"],
  //     search: query,
  //   }),
  // );

  // // Load all the result pages
  // useEffect(() => {
  //   if (
  //     patientChartQuery.isFetchingNextPage ||
  //     !patientChartQuery.hasNextPage
  //   ) {
  //     return;
  //   }
  //   patientChartQuery.fetchNextPage();
  // }, [patientChartQuery]);

  // const patientChartEntries = useMemo(
  //   () => patientChartQuery.data?.pages?.flatMap((page) => page.entries) ?? [],
  //   [patientChartQuery.data],
  // );

  const { individuals, couples, isLoadingClients, initializeClients } =
    useClientsContext();

  const clients = [...individuals, ...couples];

  const clientsFiltered = searchClientsByName(clients, query)
    .sort((a, b) =>
      getClientDisplayName(a) < getClientDisplayName(b) ? -1 : 1,
    )
    ?.filter((client) => client.patient.client_status === "patient");

  useEffect(() => {
    initializeClients();
  }, [initializeClients]);

  const { canAccessFeature, restrictAccessToPaidFeature } = useSubscription();
  const dispatch = useDispatch();

  const [showMissEmailModal, setShowMissEmailModal] = useState(false);
  const { currentCalendarTimezone } = useCalendarTime();

  const { openPatientCreator } = usePatientCreator();

  const isInEditMode = useMemo(
    () => currentSession !== undefined,
    [currentSession],
  );

  const { appointmentsInSeries, isSeriesLoaded } = useAppointmentsInSeries(
    currentSession?.patient?.orchid_user_id ?? "",
    currentSession?.appointment_series_id ?? "",
  );

  useEffect(() => {
    if (initialIntervalStart !== undefined) {
      const momentInitialIntervalStart = moment.tz(
        initialIntervalStart,
        currentCalendarTimezone,
      );

      if (hasInitialTime) {
        const timeValue = momentInitialIntervalStart.format("HH:mm");
        setTimeValue(timeValue);
      }
      setDateValue(momentInitialIntervalStart.startOf("day").valueOf());
    }
  }, [initialIntervalStart, hasInitialTime, currentCalendarTimezone]);

  const [timeValue, setTimeValue] = useState<string | undefined>();
  const [dateValue, setDateValue] = useState<number | undefined>();

  const currentIntervalStart = useMemo(() => {
    if (!dateValue || !timeValue) {
      return initialIntervalStart;
    }

    const intervalMoment = moment.tz(dateValue, currentCalendarTimezone);
    intervalMoment.add(moment.duration(timeValue));

    return intervalMoment.valueOf();
  }, [dateValue, timeValue, currentCalendarTimezone, initialIntervalStart]);

  const startTimeInLocalTimezone = useMemo(() => {
    if (!isTimeValid(timeValue) || !dateValue) {
      return "";
    }

    return moment
      .tz(
        moment
          .tz(dateValue, currentCalendarTimezone)
          .format(`YYYY-MM-DD ${timeValue}`),
        currentCalendarTimezone,
      )
      .format();
  }, [dateValue, timeValue, currentCalendarTimezone]);

  const startISO = useMemo(() => {
    if (!isTimeValid(timeValue) || !dateValue) {
      return "";
    }

    return moment
      .tz(
        moment
          .tz(dateValue, currentCalendarTimezone)
          .format(`YYYY-MM-DD ${timeValue}`),
        currentCalendarTimezone,
      )
      .toISOString();
  }, [dateValue, timeValue, currentCalendarTimezone]);

  const disablePreventNoShows = useMemo(() => {
    if (startISO) {
      return startISO < new Date().toISOString();
    }

    if (dateValue) {
      return (
        dateValue <
        moment.tz(Date.now(), currentCalendarTimezone).startOf("day").valueOf()
      );
    }

    return true;
  }, [startISO, dateValue, currentCalendarTimezone]);

  const {
    sessionTypes: initialSessionTypes,
    setSessionTypes: setInitialSessionTypes,
    providerId,
    setProviderId,
  } = useSessionTypes();
  const [sessionTypes, setSessionTypes] = useState<typeof initialSessionTypes>(
    [],
  );
  const [sessionType, setSessionType] = useState<typeof sessionTypes[number]>();
  const [meetingType, setMeetingType] = useState<MeetingType>("orchid");

  // const canShowStripeBanner = !useUser().user?.has_stripe_account_connected;

  useEffect(() => {
    const sessionTypes = initialSessionTypes.filter((el) => el.enabled);
    setSessionTypes(sessionTypes);

    if (!currentSession) {
      if (zoomIntegrated) {
        setMeetingType("zoom");
      }
    } else {
      const sessionType = sessionTypes.find(
        (el) => el.label === currentSession.appointment_type_label,
      );
      setSessionType(sessionType);

      if (currentSession.external_meeting_link && zoomIntegrated) {
        const zoomMeetingId = extractZoomMeetingId(
          currentSession.external_meeting_link,
        );
        if (zoomMeetingId) {
          setMeetingType("zoom");
        }
      }
    }
  }, [initialSessionTypes, currentSession, zoomIntegrated]);

  const [telehealth, setTelehealth] = useState(true);
  const [invoicing, setInvoicing] = useState(true);
  const [record, setRecord] = useState(false);
  const [audioSessionType, setAudioSessionType] =
    useState<AudioSessionType | null>(AUDIO_SESSION_TYPES.individual.id);
  const [externalLink, setExternalLink] = useState("");

  const [adminNote, setAdminNote] = useState("");

  const [repeatRule, setRepeatRule] = useState<
    InviteSeriesInput["repeat_rule"]
  >(currentSession?.appointment_series?.repeat_rule);

  const getSessionRecordingConfig = useCallback(() => {
    if (generateNoteOnlyWithSummary) {
      return { session_recording_source: "write-to-note" };
    }
    if (!telehealth) {
      return {
        session_recording_type: record ? audioSessionType : undefined,
        session_recording_source: record ? "live-audio-recording" : undefined,
      };
    }
    return {};
  }, [generateNoteOnlyWithSummary, telehealth, record, audioSessionType]);

  const {
    show: showConfirmEditModal,
    open: openConfirmEditModal,
    close: closeConfirmEditModal,
  } = useToggleModal(false);

  const patientName = useMemo(() => {
    if (!currentSession) {
      return "";
    }

    return currentSession.couple && currentSession.couple.length > 0
      ? getCoupleDisplayShortName(currentSession.couple)
      : getAppointmentPatientName(currentSession, true);
  }, [currentSession]);

  const patientType = useMemo(() => {
    if (!currentSession) {
      return "adult";
    }

    const isMinor = !!currentSession?.guardians?.length;
    if (isMinor) {
      return "minor";
    }

    const isCouple = !!currentSession?.couple?.length;
    if (isCouple) {
      return "couple";
    }

    return "adult";
  }, [currentSession]);

  const canCreate = useMemo(() => {
    // if (canShowStripeBanner) {
    //   return false;
    // }

    // validate session type
    if (!sessionType) {
      return false;
    }
    // validate time
    if (!startISO) {
      return false;
    }
    // validate patient
    if (!client?.patient?.orchid_user_id) {
      return false;
    }

    return true;
  }, [
    // canShowStripeBanner,
    sessionType,
    startISO,
    client?.patient?.orchid_user_id,
  ]);

  const { orchidPro } = useOrchidPro();

  const { ai_settings, telehealth_pos_code, in_person_pos_code } =
    orchidPro || {};

  useEffect(() => {
    if (currentSession) {
      setInvoicing(currentSession.statusFlags.usingInvoicing);
      setTelehealth(
        !!currentSession.session_held_on_orchid ||
          !!currentSession.external_meeting_link,
      );
      setExternalLink(currentSession.external_meeting_link ?? "");
      setRecord(
        currentSession.session_recording_source === "live-audio-recording",
      );
      setAudioSessionType(
        currentSession.session_recording_type as AudioSessionType,
      );

      if (currentSession.session_recording_source === "write-to-note") {
        setGenerateNoteOnlyWithSummary(true);
      }
    } else {
      if (ai_settings?.default_enable_audio_recorder) {
        setRecord(ai_settings.default_enable_audio_recorder);
      }

      if (
        user?.sub === "88e70f11-1a46-4051-9ef7-9db9b03ab16f" ||
        user?.sub === "219e9ee9-90db-4a24-bce9-4c9a730e5d8d"
      ) {
        setGenerateNoteOnlyWithSummary(true);
      }
    }
  }, [currentSession, ai_settings?.default_enable_audio_recorder, user?.sub]);

  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<any>();

  const setSessionTypeFromClient = useCallback(
    (selectedClient: PatientChartResponseEntry | undefined) => {
      if (!!currentSession) {
        return;
      }
      if (selectedClient?.patient?.default_session_type) {
        const defaultSessionType = sessionTypes.find(
          (sessionType) =>
            sessionType.label === selectedClient.patient.default_session_type,
        );
        if (defaultSessionType) {
          setSessionType(defaultSessionType);
        }
      } else {
        setSessionType(undefined);
      }
    },
    [currentSession, sessionTypes],
  );

  const close = useCallback(() => {
    dispatch(closeSidesheet());
  }, [dispatch]);

  const { teamMembers, practiceOwnerOrchidUserId } = useTeamContext();

  const availableProviders = useMemo(() => {
    return teamMembers.filter(
      (member) =>
        member.role !== "PRACTICE_SCHEDULER" && member.status === "active",
    );
  }, [teamMembers]);

  const handleApply = useCallback(async () => {
    if (!sessionType || !client) {
      return;
    }
    setBusy(true);
    setError(undefined);

    try {
      const sessionTypesCopy = [...sessionTypes];

      const nextSessionTypes = initialSessionTypes.reduce((prev, curr) => {
        const index = sessionTypesCopy.findIndex(
          (el) => el.label === curr.label,
        );
        if (index > -1) {
          // merge
          prev.push({ ...curr, ...sessionTypesCopy[index] });
          sessionTypesCopy.splice(index, 1);
        } else {
          prev.push(curr);
        }
        return prev;
      }, [] as typeof initialSessionTypes);
      nextSessionTypes.push(...sessionTypesCopy);

      if (!isEqual(nextSessionTypes, initialSessionTypes)) {
        await postSessionTypes(nextSessionTypes);
      }

      let zoomMeetingLink = undefined;
      if (zoomIntegrated && meetingType === "zoom" && !repeatRule) {
        try {
          const zoomMeeting = await createZoomMeeting({
            topic: `Orchid - ${sessionType.label}`,
            startTime: startTimeInLocalTimezone,
            duration: sessionType.length_min,
            timezone: currentCalendarTimezone,
          });
          zoomMeetingLink = zoomMeeting.join_url;
        } catch (error) {
          console.error(error);
        }
      }

      const template = {
        timeslot_length_minute: sessionType.length_min,
        timeslot_datetime_start: startISO,
        ...(adminNote && { admin_note: adminNote }),
        ...getSessionRecordingConfig(),
      };

      const singleSession = {
        appointment_end: getSessionEndFromSessionLength(
          startISO,
          sessionType.length_min,
        ),
        appointment_start: startISO,
        place_session_held_outside_of_orchid: !telehealth
          ? "in-person"
          : (telehealth && externalLink) || zoomMeetingLink
          ? "external-platform"
          : undefined,
        external_meeting_link:
          (telehealth && externalLink) || zoomMeetingLink
            ? externalLink || zoomMeetingLink
            : undefined,
        ...(adminNote && { admin_note: adminNote }),
        ...getSessionRecordingConfig(),
        place_of_service_code_override: !telehealth
          ? in_person_pos_code
          : telehealth_pos_code,
      };

      const appointments = !repeatRule
        ? [singleSession]
        : await Promise.all(
            getAppointmentsByRepeatRule({
              repeatRule,
              template,
              timezone: currentCalendarTimezone,
            }).map(async (appointment) => {
              let sessionZoomMeetingLink = undefined;
              if (zoomIntegrated && meetingType === "zoom") {
                const appointmentStartTimeInLocalTimezone = moment
                  .tz(appointment.appointment_start, currentCalendarTimezone)
                  .format();

                try {
                  const zoomMeeting = await createZoomMeeting({
                    topic: `Orchid - ${sessionType.label}`,
                    startTime: appointmentStartTimeInLocalTimezone,
                    duration: sessionType.length_min,
                    timezone: currentCalendarTimezone,
                  });
                  sessionZoomMeetingLink = zoomMeeting.join_url;
                } catch (error) {
                  console.error(error);
                }
              }

              return {
                ...appointment,
                external_meeting_link: sessionZoomMeetingLink || externalLink,
                place_session_held_outside_of_orchid: !telehealth
                  ? "in-person"
                  : (telehealth && externalLink) || sessionZoomMeetingLink
                  ? "external-platform"
                  : undefined,
              };
            }),
          );

      await postAppointmentSeries(
        {
          appointment_type_label: sessionType.label,
          force_book_over_blocked: true,
          patient_user_id: client.patient.orchid_user_id,
          repeat_rule: repeatRule ?? null,
          appointments,
          invoicing: !invoicing
            ? null
            : {
                automation: "manual",
              },
        },
        providerId || practiceOwnerOrchidUserId,
      );

      setInitialSessionTypes(sessionTypes);
      close();
    } catch (error) {
      setError(error);
    } finally {
      setBusy(false);
    }
  }, [
    close,
    sessionType,
    client,
    startISO,
    telehealth,
    externalLink,
    repeatRule,
    currentCalendarTimezone,
    sessionTypes,
    initialSessionTypes,
    invoicing,
    setInitialSessionTypes,
    adminNote,
    telehealth_pos_code,
    in_person_pos_code,
    zoomIntegrated,
    meetingType,
    startTimeInLocalTimezone,
    practiceOwnerOrchidUserId,
    providerId,
    getSessionRecordingConfig,
  ]);

  const [email, setEmail] = useState<string | null>(null);

  const [billingContact, setBillingContact] = useState("patient1");

  useEffect(() => {
    if (sessionTypes.length > initialSessionTypes.length) {
      setShowNewSessionTypeWarningOnCancel(true);
      setIsDirty(true);
    } else {
      setShowNewSessionTypeWarningOnCancel(false);
    }
  }, [
    sessionTypes,
    initialSessionTypes,
    setShowNewSessionTypeWarningOnCancel,
    setIsDirty,
  ]);

  useEffect(() => {
    if (!isActive) {
      return;
    }
    if (!startISO) {
      return;
    }
    if (currentSession) {
      // rescheduling, not adding, so we won't show the placeholder
      return;
    }
    // Create placeholder with optional team member ID
    dispatch(
      setNewSessionPlaceholder({
        appointment_start: startISO,
        appointment_end: getSessionEndFromSessionLength(
          startISO,
          sessionType?.length_min ?? 30,
        ),
        team_member_id: newSessionPlaceholder?.team_member_id,
      }),
    );
  }, [
    dispatch,
    startISO,
    sessionType,
    isActive,
    currentSession,
    newSessionPlaceholder?.team_member_id,
  ]);

  const trackClick = useCallback((elementName: string) => {
    track(
      PRO_CALENDAR_ANALYTICS_PAGE_NAME,
      [AMPLITUDE_COMPONENT_NAME, elementName],
      "click",
    );
  }, []);

  const handleTelehealthRadioButtonChange = useCallback(() => {
    trackClick("telehealth-radio-button");
    setIsDirty(true);
    setTelehealth((prev) => !prev);
    setMeetingType(zoomIntegrated ? "zoom" : "orchid");
  }, [trackClick, setIsDirty, zoomIntegrated]);

  const handleInPersonRadioButtonChange = useCallback(() => {
    trackClick("in-person-radio-button");
    setIsDirty(true);
    setTelehealth((prev) => !prev);
    setMeetingType("external");
    setExternalLink("");
  }, [trackClick, setIsDirty]);

  const handleAddButtonClick = useCallback(() => {
    trackClick("create-button");

    // new flow: create pateint on the fly
    if (!!client?.couple_members && client.couple_members.length > 0) {
      // check if both partners have email
      if (client.couple_members.every(({ email }) => !email)) {
        // neither has email
        setShowMissEmailModal(true);
      } else {
        handleApply();
      }
    } else {
      if (!!client?.guardians && client?.guardians.length > 0) {
        if (!client?.patient?.email && !client.guardians[0].contact.email) {
          setShowMissEmailModal(true);
        } else {
          handleApply();
        }
      } else {
        if (!client?.patient?.email) {
          setShowMissEmailModal(true);
        } else {
          handleApply();
        }
      }
    }
  }, [trackClick, client, setShowMissEmailModal, handleApply]);

  const handleUpdateButtonClick = () => {
    if (!currentSession) {
      return;
    }
    console.log({
      startISO,
      appointment_start: currentSession?.appointment_start,
    });
    const hasTimeChanged =
      startISO !== new Date(currentSession.appointment_start).toISOString();
    if (hasTimeChanged) {
      openConfirmEditModal();
    } else {
      applySessionEdits();
    }
  };

  const appointmentsToEdit = useMemo(() => {
    if (!currentSession) {
      return [];
    }

    switch (editSeriesMode) {
      case "this_session": {
        return [currentSession];
      }
      case "this_and_future_session": {
        return appointmentsInSeries.filter((appointment) => {
          return (
            new Date(appointment.appointment_start) >=
            new Date(currentSession?.appointment_start)
          );
        });
      }
      case "all_sessions": {
        return appointmentsInSeries;
      }
    }
  }, [editSeriesMode, appointmentsInSeries, currentSession]);

  const queryClient = useQueryClient();

  const updateOrCreateZoomMeeting = async () => {
    if (!currentSession || !zoomIntegrated || !sessionType) return;

    const zoomMeetingId = extractZoomMeetingId(
      currentSession.external_meeting_link,
    );

    try {
      if (meetingType === "zoom" && !currentSession.external_meeting_link) {
        const zoomMeeting = await createZoomMeeting({
          topic: `Orchid - ${sessionType.label}`,
          startTime: startTimeInLocalTimezone,
          duration: sessionType.length_min,
          timezone: currentCalendarTimezone,
        });

        if (zoomMeeting.join_url) {
          await switchSessionHeldPlace({
            appointmentId: currentSession.appointment_id,
            placeValue: "outside",
            appointmentHeldPlace: "external-platform",
            externalMeetingLink: zoomMeeting.join_url,
            ...(practiceOwnerOrchidUserId && {
              onBehalfOf: practiceOwnerOrchidUserId,
            }),
          });
        }
      } else if (meetingType === "external" && zoomMeetingId) {
        await deleteZoomMeeting({
          meetingId: zoomMeetingId,
        });
      }

      if (zoomMeetingId) {
        await updateZoomMeeting({
          meetingId: zoomMeetingId,
          topic: `Orchid - ${sessionType.label}`,
          startTime: startTimeInLocalTimezone,
          duration: sessionType.length_min,
          timezone: currentCalendarTimezone,
        });
      }

      await Promise.all(
        appointmentsToEdit
          .filter((el) => el !== currentSession)
          .map(async (appointment) => {
            const newAppointmentStartInLocalTimezone = moment
              .tz(
                moment
                  .tz(appointment.appointment_start, currentCalendarTimezone)
                  .format(`YYYY-MM-DD ${timeValue}`),
                currentCalendarTimezone,
              )
              .format();
            const zoomMeetingId = extractZoomMeetingId(
              appointment.external_meeting_link,
            );
            if (zoomMeetingId) {
              await updateZoomMeeting({
                meetingId: zoomMeetingId,
                topic: `Orchid - ${sessionType.label}`,
                startTime: newAppointmentStartInLocalTimezone,
                duration: sessionType.length_min,
                timezone: currentCalendarTimezone,
              });
            }
          }),
      );
    } catch (error) {
      console.error(error);
    }
  };

  const applySingleSessionEdits = async () => {
    if (!currentSession) {
      return;
    }

    setBusy(true);
    try {
      const placeValue = !telehealth || externalLink ? "outside" : "orchid";
      const appointmentHeldPlace = !telehealth
        ? "in-person"
        : externalLink
        ? "external-platform"
        : null;
      const externalMeetingLink =
        telehealth && externalLink ? externalLink : null;

      await switchSessionHeldPlace({
        appointmentId: currentSession.appointment_id,
        placeValue,
        appointmentHeldPlace,
        externalMeetingLink,
        sessionRecordingType: record ? audioSessionType : null,
        sessionRecordingSource: record ? "live-audio-recording" : null,
        ...(practiceOwnerOrchidUserId && {
          onBehalfOf: practiceOwnerOrchidUserId,
        }),
      });

      const showUpdateSessionType =
        sessionType &&
        sessionType.label !== currentSession.appointment_type_label;

      const rescheduledAppointment = await rescheduleAppointment({
        appointments: [
          {
            appointment_id: currentSession.appointment_id,
            new_appointment_start: startISO,
            new_appointment_end: showUpdateSessionType
              ? getSessionEndFromSessionLength(startISO, sessionType.length_min)
              : getSessionEndTime(currentSession, startISO),
            ...(adminNote && { admin_note: adminNote }),
            place_of_service_code_override: !telehealth
              ? in_person_pos_code
              : telehealth_pos_code,
            ...(showUpdateSessionType && {
              appointment_type_label: sessionType.label,
            }),
            ...(showUpdateSessionType && { price: sessionType.price }),
            ...(generateNoteOnlyWithSummary && {
              session_recording_source: "write-to-note",
            }),
          },
        ],
        force_book_over_blocked: true,
        ...(practiceOwnerOrchidUserId && {
          onBehalfOf: practiceOwnerOrchidUserId,
        }),
      });

      // TODO - not doing it's job (yet?)
      queryClient.invalidateQueries({
        queryKey: ["appointments-v2"],
      });

      dispatch(
        showSessionDetails({
          appointment: { ...currentSession, ...rescheduledAppointment },
          nextStatus: null,
        }),
      );
    } catch (error) {
      setError(error);
    } finally {
      setBusy(false);
    }

    await updateOrCreateZoomMeeting();
  };

  const applySessionEdits = async () => {
    if (!currentSession) {
      return;
    }

    if (
      !currentSession?.appointment_series?.repeat_rule ||
      editSeriesMode === "this_session"
    ) {
      applySingleSessionEdits();
      return;
    }

    if (!repeatRule || !sessionType) {
      return;
    }

    setBusy(true);
    try {
      const showUpdateSessionType =
        sessionType.label !== currentSession.appointment_type_label;

      const template = {
        timeslot_length_minute: sessionType.length_min,
        timeslot_datetime_start: startISO,
        ...getSessionRecordingConfig(),
        place_session_held_outside_of_orchid: !telehealth
          ? "in-person"
          : telehealth && externalLink
          ? "external-platform"
          : undefined,
        external_meeting_link:
          telehealth && externalLink ? externalLink : undefined,
        place_of_service_code_override: !telehealth
          ? in_person_pos_code
          : telehealth_pos_code,
        ...(adminNote && { admin_note: adminNote }),
      };

      const appointments = await Promise.all(
        getAppointmentsByRepeatRule({
          repeatRule,
          template,
          timezone: currentCalendarTimezone,
        }),
      );

      const rescheduledAppointment = await modifyAppointmentSeries(
        currentSession.appointment_series_id,
        {
          invite_series_input: {
            appointment_type_label: showUpdateSessionType
              ? sessionType.label
              : currentSession.appointment_type_label,
            force_book_over_blocked: true,
            patient_user_id: currentSession?.patient?.orchid_user_id,
            repeat_rule: repeatRule ?? null,
            appointments,
            invoicing: !invoicing
              ? null
              : {
                  automation: "manual",
                },
          },
          update_from_appointment_id: currentSession.appointment_id,
          invoicing_series: invoicing ? true : false,
        },
      );

      // TODO - not doing it's job (yet?)
      queryClient.invalidateQueries({
        queryKey: ["appointments-v2"],
      });

      dispatch(
        showSessionDetails({
          appointment: { ...currentSession, ...rescheduledAppointment },
          nextStatus: null,
        }),
      );
    } catch (error) {
      setError(error);
    } finally {
      setBusy(false);
    }

    await updateOrCreateZoomMeeting();
  };

  const isWaitingForOtherAppointmentsInSeries =
    editSeriesMode !== "this_session" && !isSeriesLoaded;

  return (
    <>
      {isInEditMode &&
        currentSession?.appointment_series?.repeat_rule &&
        editSeriesMode === "this_session" && (
          <SidesheetWarning
            message={messages.youreEditingOneAppointmentInTheSeries}
          />
        )}

      {error && <SidesheetWarning message={error.toString()} />}

      <div className={addToCalendarStyles["body"]}>
        {/* <ConnectStripeBanner
          onOpenStripeModal={close}
          amplitudePageName={PRO_CALENDAR_ANALYTICS_PAGE_NAME}
          amplitudeComponentName={AMPLITUDE_COMPONENT_NAME}
        /> */}

        <div className={addToCalendarStyles["section"]}>
          {currentSession && (
            <>
              <div className={sessionSidesheetStyles["patient-type-and-name"]}>
                <PatientTypeTag type={patientType} />
                <div className={sessionSidesheetStyles["patient-name"]}>
                  <Link
                    to={`/pro-dashboard/patient-charts/${
                      currentSession!.patient?.cognito_sub
                    }`}
                    onClick={() => {
                      trackClick("view-patient-chart-link");
                    }}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {patientName}
                  </Link>
                </div>
              </div>
              <hr className={sessionSidesheetStyles["divider"]} />
            </>
          )}

          <div className={addToCalendarStyles["section__title"]}>
            {messages.sessionDetails}
          </div>

          <div className={styles["location-panel"]}>
            <div className={styles["telehealth-button-group"]}>
              <RadioButton
                name="telehealth_in_person"
                label="Telehealth"
                checked={telehealth}
                onChange={handleTelehealthRadioButtonChange}
                className={styles["custom-radio"]}
                // disabled={editSeriesMode !== "this_session"}
              />
              <RadioButton
                name="telehealth_in_person"
                label="In-person"
                checked={!telehealth}
                onChange={handleInPersonRadioButtonChange}
                className={styles["custom-radio"]}
                // disabled={editSeriesMode !== "this_session"}
              />
            </div>

            {(user?.sub === "88e70f11-1a46-4051-9ef7-9db9b03ab16f" ||
              user?.sub === "219e9ee9-90db-4a24-bce9-4c9a730e5d8d") && (
              <div className={styles["add-to-calendar__form-row"]}>
                <div className="form-check" style={{ marginLeft: "4px" }}>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="generate-note-only-with-summary"
                    checked={generateNoteOnlyWithSummary}
                    onChange={(e) =>
                      setGenerateNoteOnlyWithSummary(e.target.checked)
                    }
                    style={{
                      transform: "scale(1.2)",
                      marginRight: "8px",
                    }}
                  />
                  <label
                    className="form-check-label"
                    htmlFor="generate-note-only-with-summary"
                    style={{ fontSize: "0.75rem", marginLeft: "4px" }}
                  >
                    <b>Write Summary</b>
                    <br />{" "}
                    <i className="text-muted" style={{ fontSize: "0.7rem" }}>
                      AI will generate the note from your summary
                    </i>
                  </label>
                </div>
              </div>
            )}

            <LocationSelector
              telehealth={telehealth}
              meetingType={meetingType}
              externalLink={externalLink}
              setIsDirty={setIsDirty}
              setExternalLink={setExternalLink}
              setMeetingType={setMeetingType}
              trackClick={trackClick}
              // disabled={editSeriesMode !== "this_session"}
              zoomIntegrated={zoomIntegrated}
            />
          </div>

          {canAccessFeature("audio-recorder") && !telehealth ? (
            <>
              <div className={styles["audio-recorder-toggle"]}>
                <ToggleSwitch
                  // disabled={!invoicing}
                  checked={record}
                  onChange={(e) => {
                    if (!audioSessionType && e.target.checked) {
                      setAudioSessionType(AUDIO_SESSION_TYPES.individual.id);
                    }
                    setRecord(e.target.checked);
                  }}
                />
                <span className={styles["audio-recorder-tag"]}>
                  <AIEmoji16 />
                  AI Audio Recorder
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip id="button-tooltip">
                        Orchid's AI audio recorder is for in-person sessions to
                        record and summarize appointments automatically, helping
                        you save time on documentation.
                      </Tooltip>
                    }
                  >
                    <OutlineInfoCircle16 className="blue" />
                  </OverlayTrigger>
                </span>
              </div>
              {record && (
                <div className={styles["radio-group"]}>
                  {Object.values(AUDIO_SESSION_TYPES).map((el) => (
                    <RadioButton
                      // disabled={!invoicing}
                      key={el.id}
                      type={"radio"}
                      name={"audio-session-type"}
                      label={el.titleStringId}
                      value={el.id}
                      onChange={(e) => {
                        e.target.value !== audioSessionType &&
                          setAudioSessionType(
                            e.target.value as AudioSessionType,
                          );
                      }}
                      checked={audioSessionType === el.id}
                    />
                  ))}
                </div>
              )}
            </>
          ) : null}

          {!currentSession && (
            <div>
              <div className={styles["label-text"]}>
                {messages.invitepatient}
                <RequiredAsterisk />
              </div>
              <CustomSelect
                options={
                  isLoadingClients
                    ? []
                    : [
                        ...clientsFiltered.map((client) => ({
                          value: client.patient.orchid_user_id,
                          client: client,
                        })),
                        {
                          value: "new-client",
                          label: `+ Add ${
                            query ? `${query}` : ""
                          } as a new patient`,
                        },
                      ]
                }
                getOptionLabel={(option) => {
                  return option.client
                    ? getClientDisplayName(option.client)
                    : option.label;
                }}
                getOptionValue={(option) => option.value}
                formatOptionLabel={(option) => {
                  return option.client ? (
                    option.client.couple_members ? (
                      <div className={styles["invite-patient-option--couple"]}>
                        <OutlineUsers16 />
                        <div>{getClientDisplayName(option.client)}</div>
                      </div>
                    ) : (
                      <div className={styles["invite-patient-option"]}>
                        <div>{getClientDisplayName(option.client)}</div>{" "}
                        <span>{option.client.patient.dob}</span>
                      </div>
                    )
                  ) : (
                    option.label
                  );
                }}
                onChange={(el) => {
                  if (el.value === "new-client") {
                    openPatientCreator({
                      amplitudePageName: PRO_CALENDAR_ANALYTICS_PAGE_NAME,
                      onApply: (nextV: PatientChartResponseEntry) => {
                        setIsDirty(true);
                        setClient(nextV);
                        setSessionTypeFromClient(nextV);
                      },
                    });
                  } else {
                    const selectedClient = clientsFiltered.find(
                      (client) => client.patient.orchid_user_id === el.value,
                    );
                    setClient(selectedClient);
                    setSessionTypeFromClient(selectedClient);
                  }
                }}
                placeholder="Search patient name"
                value={
                  client
                    ? {
                        value: client.patient.orchid_user_id,
                        label: getClientDisplayName(client),
                      }
                    : undefined
                }
                isSearchable
                autoFocus
                isLoading={isLoadingClients}
                onInputChange={(value) => setQuery(value)}
              />
            </div>
          )}

          {!currentSession && availableProviders.length > 1 && (
            <div className={styles["provider-selector"]}>
              <div className={styles["label-text"]}>Provider</div>
              <CustomSelect
                options={availableProviders.map((member) => ({
                  value: member.orchid_user_id,
                  label: `${member.first_name} ${member.last_name} (${
                    member.role === "OWNER" ? "Owner" : "Team Member"
                  })`,
                  member: member,
                }))}
                getOptionLabel={(option) => option.label}
                getOptionValue={(option) => option.value}
                onChange={(el) => {
                  setIsDirty(true);
                  setProviderId(el.value);
                }}
                placeholder="Select provider"
                value={
                  providerId
                    ? (() => {
                        const selectedMember = availableProviders.find(
                          (m) => m.orchid_user_id === providerId,
                        );
                        return selectedMember
                          ? {
                              value: providerId,
                              label: `${selectedMember.first_name} ${
                                selectedMember.last_name
                              } (${
                                selectedMember.role === "OWNER"
                                  ? "Owner"
                                  : "Team Member"
                              })`,
                            }
                          : undefined;
                      })()
                    : undefined
                }
                isSearchable={false}
              />
            </div>
          )}

          <SessionTypeSelector
            amplitudePageName={PRO_CALENDAR_ANALYTICS_PAGE_NAME}
            sessionTypes={sessionTypes}
            sessionType={sessionType}
            setIsDirty={setIsDirty}
            setSessionType={setSessionType}
            setSessionTypes={setSessionTypes}
            trackClick={trackClick}
            disabled={
              // editSeriesMode !== "this_session" ||
              !invoicing && !!currentSession
            }
          />

          <SessionDateAndTime
            dateValue={dateValue}
            setIsDirty={setIsDirty}
            setDateValue={setDateValue}
            timeValue={timeValue}
            setTimeValue={setTimeValue}
            trackClick={trackClick}
            canChangeDate
          />

          <SessionRepeatRuleEditor
            className={styles["repeat-rule"]}
            value={repeatRule}
            onChange={(repeatRule) => {
              trackClick("session-repeat-option");
              setIsDirty(true);
              setRepeatRule(repeatRule);
            }}
            timezone={currentCalendarTimezone}
            intervalStart={currentIntervalStart}
            // disabled={isInEditMode}
          />
        </div>

        {restrictAccessToPaidFeature(user) ? null : (
          <div className={addToCalendarStyles["section"]}>
            <div className={addToCalendarStyles["section__title"]}>
              {messages.paymentMethod}
            </div>
            <RadioButton
              name="invoicing"
              label="Invoice Patient"
              checked={invoicing}
              onChange={() => {
                setIsDirty(true);
                setInvoicing(!invoicing);
              }}
              className={styles["custom-radio"]}
              onClick={() => trackClick("dont-prevent-no-shows-radio-button")}
              disabled={isInEditMode}
            />
            {invoicing && (
              <div className={styles["info"]}>
                <div className={styles["info-line-1"]}>
                  Standard payment method
                </div>
                Your patient will receive an email invitation for the session,
                and Orchid will send the invoice on your behalf when you're
                ready.
              </div>
            )}
            <RadioButton
              name="invoicing"
              label="Pre-Authorize Patient's Credit Card"
              checked={!invoicing}
              onChange={() => {
                setIsDirty(true);
                setInvoicing(!invoicing);
              }}
              className={styles["custom-radio"]}
              disabled={
                isInEditMode ||
                disablePreventNoShows ||
                disableStripeFeatures(user)
              }
              onClick={() => trackClick("do-prevent-no-shows-radio-button")}
            />
            {!invoicing && (
              <div className={styles["info"]}>
                <div className={styles["info-line-1"]}>
                  Ensures you'll be paid upfront
                </div>
                Your patient will receive an email invitation for the session,
                and the appointment will only be confirmed once they secure
                their booking with payment details.
              </div>
            )}
          </div>
        )}

        <div className={addToCalendarStyles["section"]}>
          <div className={addToCalendarStyles["section__title"]}>
            {messages.adminNote}
            <OverlayTrigger
              placement="right"
              overlay={
                <Tooltip id="admin-note-tooltip">
                  {messages.adminNoteTooltip}
                </Tooltip>
              }
            >
              <OutlineInfoCircle16 className={"blue ml-1"} />
            </OverlayTrigger>
          </div>
          <Form.Control
            as="textarea"
            rows={5}
            placeholder={messages.enterNote}
            value={adminNote}
            onChange={(event) => {
              setAdminNote(event.target.value);
            }}
            // disabled={editSeriesMode !== "this_session"}
          />
        </div>
      </div>

      <div className={addToCalendarStyles["footer"]}>
        {isInEditMode ? (
          <Button
            className={addToCalendarStyles["button"]}
            variant={"primary"}
            disabled={busy || isWaitingForOtherAppointmentsInSeries}
            onClick={handleUpdateButtonClick}
          >
            {isWaitingForOtherAppointmentsInSeries
              ? "Loading..."
              : messages.update}
          </Button>
        ) : (
          <Button
            className={addToCalendarStyles["button"]}
            variant={"primary"}
            disabled={busy || !canCreate}
            onClick={handleAddButtonClick}
          >
            {messages.add}
          </Button>
        )}
      </div>

      {showMissEmailModal && client && (
        <MissingEmailModal
          error={error}
          setError={setError}
          showMissEmailModal={showMissEmailModal}
          setShowMissEmailModal={setShowMissEmailModal}
          email={email}
          client={client}
          setEmail={setEmail}
          setBillingContact={setBillingContact}
          billingContact={billingContact}
          handleApply={handleApply}
          trackClick={trackClick}
          invoicing={invoicing}
        />
      )}

      {showConfirmEditModal && (
        <ConfirmModal
          show={showConfirmEditModal}
          onConfirm={() => {
            closeConfirmEditModal();
            applySessionEdits();
          }}
          onCancel={() => {
            closeConfirmEditModal();
          }}
          labelTitle={messages.readyToReschedule}
          labelCancel={messages.cancel}
          labelConfirm={messages.reschedule}
        >
          If you reschedule this session, <b>please message your client</b> to
          notify them about this update. Orchid will not automatically notify
          them for you.
        </ConfirmModal>
      )}
    </>
  );
};

export default AddOrEditSession;
